// @ts-strict-ignore
import { OrderDetailsFragment, OrderErrorFragment } from "@dashboard/graphql";
import React from "react";

import { FormData } from "../OrderDraftDetailsProducts/OrderDraftDetailsProducts";
import { OrderDraftDetailsGroupedTable } from "./OrderDraftDetailsGroupedTable";

interface OrderDraftDetailsDatagridProps {
  loading: boolean;
  lines: OrderDetailsFragment["lines"];
  errors: OrderErrorFragment[];
  orderId?: string;
  onOrderLineChange: (id: string, data: FormData) => void;
  onOrderLineRemove: (id: string) => void;
  onShowMetadata?: (id: string) => void;
}

export const OrderDraftDetailsDatagrid = ({
  lines,
  errors,
  loading,
  orderId,
  onOrderLineChange,
  onOrderLineRemove,
  onShowMetadata,
}: OrderDraftDetailsDatagridProps) => {
  return (
    <OrderDraftDetailsGroupedTable
      lines={lines}
      errors={errors}
      loading={loading}
      orderId={orderId}
      onOrderLineChange={onOrderLineChange}
      onOrderLineRemove={onOrderLineRemove}
      onShowMetadata={onShowMetadata}
    />
  );
};
